import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import CheckSingle from '~/components/UI/Forms/Checkboxes/icon/check-single'

import { cn } from '~/lib/utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    className?: string
  }
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-s w-s shrink-0 border-2 border-blue-d-40 ring-offset-white focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-blue-m data-[state=checked]:bg-blue-m data-[state=checked]:text-blue-d disabled:data-[state=checked]:border-grey-m disabled:data-[state=unchecked]:border-grey-m disabled:data-[state=checked]:bg-grey-m disabled:hover:data-[state=unchecked]:border-grey-m dark:border-blue-d-20 dark:ring-offset-neutral-950 dark:focus-visible:ring-neutral-300 dark:data-[state=checked]:border-white dark:data-[state=checked]:bg-white dark:data-[state=checked]:text-white',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn(
        'flex items-center justify-center text-white dark:text-blue-d'
      )}
    >
      <CheckSingle fill={''} width={'1rem'} height={'1rem'} title={''} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
